import { useEffect, useState } from 'react';

import variables from 'src/styles/_commonVariables.module.scss';

export const useTextLengthLimit = (clientWidth: number) => {
  const [textLengthLimit, setTextLengthLimit] = useState<number>(85);

  useEffect(() => {
    if (clientWidth <= Number(variables.psychicListDesktopWidthPointQuery)) {
      setTextLengthLimit(75);
    } else {
      setTextLengthLimit(85);
    }
  }, [clientWidth]);

  return textLengthLimit;
};
